import { InsuredTripTravelCardRequest } from "./insured-trip-travel-card-request";

export class InsuredTripTravelCardRequestMultiple {
    id: number = (new Date()).getTime();
    type: string = 'travel_card';
    travelInsuranceMembers: Array<InsuredTripTravelCardRequest> = [];
}
